export default (start: number, end: number, step: number): number[] =>
  Array.from({ length: Math.floor((end - start) / step) + 1 }).map((_, i) => start + i * step);
